import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Input, Table } from "reactstrap";
import * as Yup from "yup";
import { GET_DOCUMENT_OUTCOME_SUCCESS, SAVE_DOCUMENT_OUTCOME } from "../../redux/Action/actionTypes";
import ToastNotifier from "../../components/ToastNotifier/toastNotifier";
import { RootState } from "../../redux/Reducer";
import { useNavigate } from "react-router-dom";

interface InitialValues {
  rounds: number;
  agreement: boolean;
  targetOutcome: number;
  paymentTermsTargetAchieved: string;
  incoTermsTargetAchieved: string;
  localStockTargetAchieved: string;
  discountTerms: string;
  paymentTermsOutcome: string;
  incoTermsOutcome: string;
  localStockOutcome: string;
}

const DocumentOutcome = () => {
  const [isNextDisabled, setIsNextDisabled] = useState<boolean>(true);
  const contractStatus = useSelector(
    (state: RootState) => state.dashboardData.contractStatus
  );
  const detailedTargetValue = useSelector(
    (state: RootState) => state.dashboardData?.detailedOverviewData?.targetValue
  );
  const closeNegotiationTargetValue = useSelector(
    (state: RootState) => state.dashboardData?.closeNegotiaitionData?.targetValue
  );
  const detailedGetId = useSelector(
    (state: RootState) => state.dashboardData?.detailedOverviewData?.planNegotiationActions?.
      negotiationId
  );
  const closeNegoGetId = useSelector(
    (state: RootState) => state.dashboardData?.closeNegotiaitionData?.planNegotiationActions?.
      negotiationId
  );

  const TargetValueData =
    contractStatus === "inReview"
      ? closeNegotiationTargetValue
      : detailedTargetValue;
  const GetId =
    contractStatus === "inReview"
      ? closeNegoGetId
      : detailedGetId;
  const DocumentOutcomeData = useSelector(
    (state: RootState) => state.dashboardData.closeNegotiaitionData.others
  );
  
  useEffect(() => {
    if (DocumentOutcomeData?.discountTerms == null) {
      formik.setValues({ ...formik.values });
    }
    else {
      formik.setValues({ ...formik.values, ...DocumentOutcomeData });
    }
    formik.validateForm();
  }, []);

  const validationSchema = Yup.object({
    targetOutcome: Yup.number()
      .min(-1000, "Value should be greater than or equal to -1000")
      .max(1000, "Value should be less than or equal to 1000")
      .required("This is a required field")
      .test(
        "max-decimals",
        "Maximum 2 decimal places allowed",
        (value) =>
          value === undefined || /^-?\d+(\.\d{1,2})?$/.test(String(value))
      ),
    discountTerms: Yup.string().max(1000, "Maximum 1000 characters allowed").required("This is a required field"),
    paymentTermsOutcome: TargetValueData?.paymentTerms === "" ? Yup.string() : Yup.string().max(1000, "Maximum 1000 characters allowed").required("This is a required field"),
    incoTermsOutcome: TargetValueData?.incoTerms === "" ? Yup.string() : Yup.string().max(1000, "Maximum 1000 characters allowed").required("This is a required field"),
    localStockOutcome: TargetValueData?.localStock === "" ? Yup.string() : Yup.string().max(1000, "Maximum 1000 characters allowed").required("This is a required field"),
    paymentTermsTargetAchieved: Yup.string(),
    incoTermsTargetAchieved: Yup.string(),
    localStockTargetAchieved: Yup.string(),
  });

  const initialValues: InitialValues = {
    rounds: TargetValueData?.negotiationRounds
      ? TargetValueData?.negotiationRounds
      : 3,
    targetOutcome: 0,
    agreement: false,
    paymentTermsTargetAchieved: "Not applicable",
    incoTermsTargetAchieved: "Not applicable",
    localStockTargetAchieved: "Not applicable",
    discountTerms: "",
    paymentTermsOutcome: "",
    incoTermsOutcome: "",
    localStockOutcome: "",
  };
  const formik = useFormik({
    initialValues,
    validationSchema,
    validateOnBlur: true,
    validateOnChange: false,
    validateOnMount: true,
    onSubmit: (values) => { },
  });

  useEffect(() => {
    formik.validateForm().then((errors) => {
      if (formik.values.agreement) {
        setIsNextDisabled(Object.keys(errors).length > 0);
      } else {
        setIsNextDisabled(false);
      }
    });
  }, [formik.values]);

  const dispatch = useDispatch();
  const adjustValue = (field: "targetOutcome", direction: "inc" | "dec") => {
    let raw = formik.values[field];
    // Convert to number and default to 0 if invalid
    const current =
      typeof raw === "number" && !isNaN(raw)
        ? raw
        : parseFloat(raw as unknown as string);
    const safeCurrent = isNaN(current) ? 0 : current;
    const updated = +(safeCurrent + (direction === "inc" ? 0.1 : -0.1)).toFixed(
      1
    );
    formik.setFieldTouched(field, false);
    formik.setFieldValue(field, updated, false);
  };
  const navigate = useNavigate();

  const handleProceedClick = () => {
    let AchievedTarget = (
      TargetValueData?.negotiationTarget - formik.values.targetOutcome
    ).toFixed(2);
    const dataToSend = {
      id: GetId,
      TargetOutcome: formik.values.targetOutcome,
      DiscountTerms: formik.values.discountTerms,
      PaymentTermsOutcome: formik.values.paymentTermsOutcome,
      IncoTermsOutcome: formik.values.incoTermsOutcome,
      LocalStockOutcome: formik.values.localStockOutcome,
      PaymentTermsTargetAchieved: formik.values.paymentTermsTargetAchieved,
      IncoTermsTargetAchieved: formik.values.incoTermsTargetAchieved,
      LocalStockTargetAchieved: formik.values.localStockTargetAchieved,
      AchievedTarget: AchievedTarget,
      EndedWithArgument: formik.values.agreement,
      Status: "In Review"
    };
    dispatch({
      type: SAVE_DOCUMENT_OUTCOME,
      payload: dataToSend,
      meta: {
        onSuccess: () => {
          navigate("/ReviewNegotiation");
        },
      },
    });
    dispatch({
      type: GET_DOCUMENT_OUTCOME_SUCCESS,
      payload: dataToSend,
    });
  };

  useEffect(() => {
    if (TargetValueData?.length == 0 || TargetValueData == undefined) {
      navigate('/')
    }
  }, [])
  return (
    <div className="Document-Outcome">
      <form onSubmit={formik.handleSubmit}>
        <h6 className="DocumentOutcome-heading">
          Please Document the outcome of this negotiation:
        </h6>
        <div className="gray-containers">
          <div className="text-label">
            How many <b>negotiation rounds</b> did you conduct?
          </div>
          <div className="rounds">
            <select
              className="form-select form-select-sm Rounds-container"
              name="rounds"
              value={formik.values.rounds}
              onChange={formik.handleChange}
            >
              {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((num) => (
                <option key={num} value={num}>
                  {num}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="gray-container-second">
          <div className="text-label">
            Did the negotiation end with an <b>agreement</b>?
          </div>
          <div className="YesNoButtons">
            <button
              type="button"
              className={`Yes-button ${formik.values.agreement ? "selected" : ""
                }`}
              onClick={() => formik.setFieldValue("agreement", true)}
            >
              Yes
            </button>
            <button
              type="button"
              className={`Yes-button ${!formik.values.agreement ? "selected" : ""
                }`}
              onClick={() => formik.setFieldValue("agreement", false)}
            >
              {" "}
              No
            </button>
          </div>
        </div>
        {formik.values.agreement && (
          <div>
            <h6 className="DocumentOutcome-heading">
              What price changes and conditions have been agreed upon?
            </h6>
            <div>
              <Table responsive>
                <thead className="bg-light">
                  <tr>
                    <th> </th>
                    <th>Initial target</th>
                    <th>Outcome</th>
                    <th>Target achievement</th>
                  </tr>
                </thead>
                <tbody>
                  {/* Row 1: Price change */}
                  <tr>
                    <td className="grey-row">
                      <b>Price change</b>
                    </td>
                    <td className="grey-row">
                      {TargetValueData?.negotiationTarget}%
                    </td>
                    <td className="grey-row">
                      <div className="DocOutcome-IncDecBtn">
                        <button
                          type="button"
                          className="Inc-Dec-button"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="25"
                            height="25"
                            type="button"
                            onClick={() => adjustValue("targetOutcome", "dec")}
                            fill="#004E8C"
                            className="bi bi-dash-circle"
                            viewBox="0 0 16 16"
                          >
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                            <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8" />
                          </svg>
                        </button>
                        <div>
                          <input
                            type="number"
                            name="targetOutcome"
                            className="form-control form-control-sm  no-spinner number-priceChange"
                            value={formik.values.targetOutcome}
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                          />
                          <div>
                            {formik.errors.targetOutcome &&
                              formik.touched.targetOutcome && (
                                <div
                                  className="error-text"
                                  style={{ justifyContent: "space-around" }}
                                >
                                  {formik.errors.targetOutcome}
                                </div>
                              )}
                          </div>
                        </div>
                        <button
                          type="button"
                          className="Inc-Dec-button"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="25"
                            height="25"
                            type="button"
                            onClick={() => adjustValue("targetOutcome", "inc")}
                            fill="#004E8C"
                            className="bi bi-plus-circle"
                            viewBox="0 0 16 16"
                          >
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                            <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
                          </svg>
                        </button>
                      </div>
                    </td>
                    <td className="grey-row" >
                      {(
                        TargetValueData?.negotiationTarget -
                        formik.values.targetOutcome
                      ).toFixed(2)}
                      %
                    </td>
                  </tr>
                  {/* Row 2: Discount terms */}
                  <tr >
                    <td className="grey-row2 column1">
                      <b>Discount terms</b>
                    </td>
                    <td className="grey-row2 column2" ></td>
                    <td className="grey-row2 column3" >
                      <Input
                        type="textarea"
                        name="discountTerms"
                        rows={3}
                        placeholder="..."
                        value={formik.values.discountTerms}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        className='input-paymentTermsOutcome'

                      />
                      <div>
                        {formik.touched.discountTerms
                          &&
                          formik.errors.discountTerms
                          && (
                            <div
                              className="error-text"
                              style={{ justifyContent: "space-around" }}
                            >
                              {formik.errors.discountTerms
                              }
                            </div>
                          )}
                      </div>
                    </td>
                    <td className="grey-row2 column4"></td>
                  </tr>
                  {/* Row 3: Payment terms */}
                  {TargetValueData?.paymentTerms !== "" && (
                    <tr>
                      <td className="grey-row">
                        <b>Payment terms</b>
                      </td>
                      <td className="grey-row">
                        {TargetValueData?.paymentTerms}
                      </td>
                      <td className="grey-row">
                        {" "}
                        <Input
                          type="textarea"
                          name="paymentTermsOutcome"
                          rows={3}
                          placeholder="..."
                          value={formik.values.paymentTermsOutcome}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          className="input-paymentTermsOutcome"
                        />
                        <div>
                          {" "}
                          {formik.errors.paymentTermsOutcome &&
                            formik.touched.paymentTermsOutcome && (
                              <div
                                className="error-text"
                                style={{ justifyContent: "space-around" }}
                              >
                                {formik.errors.paymentTermsOutcome}
                              </div>
                            )}
                        </div>
                      </td>
                      <td className="grey-row">
                        <div className="DocOut-target-options">
                          {[
                            "Target achieved",
                            "Target missed",
                            "Not applicable",
                          ].map((option) => {
                            const id = `paymentTermsTargetAchieved-${option}`;
                            return (
                              <div className="custom-radio" key={id}>
                                <input
                                  type="radio"
                                  name="paymentTermsTargetAchieved"
                                  id={id}
                                  value={option}
                                  checked={
                                    formik.values.paymentTermsTargetAchieved === option
                                  }
                                  onChange={formik.handleChange}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={id}
                                >
                                  {option}
                                </label>
                              </div>
                            );
                          })}
                        </div>
                      </td>
                    </tr>
                  )}
                  {/* Row 4: Inco terms */}
                  {TargetValueData?.incoTerms !== "" && (
                    <tr>
                      <td className="grey-row2">
                        <b>Inco terms</b>
                      </td>
                      <td className="grey-row2">
                        {TargetValueData?.incoTerms}
                      </td>
                      <td className="grey-row2">
                        <Input
                          type="textarea"
                          name="incoTermsOutcome"
                          rows={3}
                          placeholder="..."
                          value={formik.values.incoTermsOutcome}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          className="input-paymentTermsOutcome"
                        />
                        <div>
                          {" "}
                          {formik.errors.incoTermsOutcome
                            &&
                            formik.touched.incoTermsOutcome
                            && (
                              <div
                                className="error-text"
                                style={{ justifyContent: "space-around" }}
                              >
                                {formik.errors.incoTermsOutcome
                                }
                              </div>
                            )}
                        </div>
                      </td>
                      <td className="grey-row2">
                        <div className="DocOut-target-options">
                          {[
                            "Target achieved",
                            "Target missed",
                            "Not applicable",
                          ].map((option) => {
                            const id = `incoTermsTargetAchieved-${option}`;
                            return (
                              <div className="custom-radio" key={id}>
                                <input
                                  type="radio"
                                  name="incoTermsTargetAchieved"
                                  id={id}
                                  value={option}
                                  checked={formik.values.incoTermsTargetAchieved === option}
                                  onChange={formik.handleChange}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={id}
                                >
                                  {option}
                                </label>
                              </div>
                            );
                          })}
                        </div>
                      </td>
                    </tr>
                  )}
                  {/* Row 5: Local stock */}
                  {TargetValueData?.localStock !== "" && (
                    <tr>
                      <td className="grey-row">
                        <b>Local stock</b>
                      </td>
                      <td className="grey-row">
                        {TargetValueData?.localStock}
                      </td>
                      <td className="grey-row">
                        <Input
                          type="textarea"
                          name="localStockOutcome"
                          rows={3}
                          placeholder="..."
                          value={formik.values.localStockOutcome}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          className="input-paymentTermsOutcome"
                        />
                        <div>
                          {" "}
                          {formik.errors.localStockOutcome &&
                            formik.touched.localStockOutcome && (
                              <div
                                className="error-text"
                                style={{ justifyContent: "space-around" }}
                              >
                                {formik.errors.localStockOutcome}
                              </div>
                            )}
                        </div>
                      </td>
                      <td className="grey-row">
                        <div className="DocOut-target-options">
                          {[
                            "Target achieved",
                            "Target missed",
                            "Not applicable",
                          ].map((option) => {
                            const id = `localStockTargetAchieved-${option}`;
                            return (
                              <div className="custom-radio" key={id}>
                                <input
                                  type="radio"
                                  name="localStockTargetAchieved"
                                  id={id}
                                  value={option}
                                  checked={formik.values.localStockTargetAchieved === option}
                                  onChange={formik.handleChange}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={id}
                                >
                                  {option}
                                </label>
                              </div>
                            );
                          })}
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </div>
        )}
      </form>
      <div className="button-div">
        <button
          className="Proceed-button"
          disabled={isNextDisabled}
          onClick={handleProceedClick}
        >
          Proceed to negotiation review
        </button>
      </div>
      <ToastNotifier></ToastNotifier>
    </div>
  );
};
export default DocumentOutcome;
